import React, { useMemo } from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { CalendarMeetingTemplateFormData } from 'modules/calendar/constants/calendarMeetingTemplateSchema';
import { SummaryField } from 'common/ui/SummaryField';
import { UseUserCalendarReturnData } from 'modules/calendar/hooks/useUserCalendar';
import { mapToSummaryMeetingTemplate } from 'modules/calendar/utils/mapToSummaryMeetingTemplate';
import { Button } from 'system/atoms';
import { SxProps } from '@mui/material/styles';

const container: SxProps = {
  display: 'flex',
  alignItems: 'start',
  flexDirection: 'column',
  gap: '30px',
  mt: 5
};

type Props = {
  formData: CalendarMeetingTemplateFormData;
  userCalendars: UseUserCalendarReturnData;
  onEditPressed: () => void;
  onSavePressed: () => void;
  isReadOnly?: boolean;
  // On its own page the H1 already names it, so the heading repeats it.
  hideHeading?: boolean;
};

export const CalendarMeetingTemplateFormSummary: React.FC<Props> = ({
  formData,
  userCalendars,
  onEditPressed,
  onSavePressed,
  isReadOnly,
  hideHeading
}) => {
  const { palette } = useTheme();

  const summaryFields = useMemo(() => {
    return mapToSummaryMeetingTemplate(formData, userCalendars);
  }, [formData, userCalendars]);

  return (
    <Box sx={container}>
      {!hideHeading && (
        <Typography
          variant="h4"
          fontSize="30px"
          color={palette.customGrey.medium}
        >
          Summary
        </Typography>
      )}

      {summaryFields.map(({ key, label, value }) => (
        <SummaryField key={key} label={label} value={value} />
      ))}
      {!isReadOnly && (
        <Box display="flex" gap={2}>
          <Button onClick={onSavePressed} variant="primary">
            Save
          </Button>
          <Button component="button" variant="tertiary" onClick={onEditPressed}>
            Edit
          </Button>
        </Box>
      )}
    </Box>
  );
};
